import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Drawer } from 'components/Ui';
import { accountIcons } from 'images';
import { resetPaymentRemovalSucessful } from 'containers/PrimoProfile/actions';
import * as drawerActions from 'containers/DrawerManager/actions';
import styles from './styles.scss';

// eslint-disable-next-line no-shadow
function PaymentRemovalSuccessDrawer({ open, resetPaymentRemovalSucessful }) {
  return (
    <Drawer
      open={open}
      headerTitle="Payment Methods"
      onClose={() => {
        resetPaymentRemovalSucessful();
      }}
    >
      <Fragment>
        <div className={styles.submittedDrawer}>
          <div className={styles.submitSuccessContainer}>
            <div className={styles.submitSuccess}>
              <img src={accountIcons.Finger} alt="finger" />
            </div>
            <div className={styles.submitSuccess}>
              Your selected payment method has been removed.
            </div>
          </div>
        </div>
      </Fragment>
    </Drawer>
  );
}

PaymentRemovalSuccessDrawer.propTypes = {
  open: PropTypes.bool,
  resetPaymentRemovalSucessful: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {
  resetPaymentRemovalSucessful,
  showDrawer: drawerActions.showDrawer,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentRemovalSuccessDrawer);
